import { ApiClient } from '../../api/ApiClient';
import { v2 } from '../../api/ApiInterfaceV2';
import { AccountBillingData } from '../../api/endpoints/admin';
import { AppEvents } from '../AppEvents';
import { ModelBroker } from '../dashboard/Models';
import { CoolWriteStore } from '../packages/voting/VotingViewState';
import { createScope } from '../Scope';

export class ManageBillingSettingsModel extends CoolWriteStore<Partial<AccountBillingData>>({}) {

    public readonly id = '$';

    public static create(_broker: ModelBroker) {
        return new ManageBillingSettingsModel();
    }
}

// const onBoardPatch = (broker: ModelBroker) => (patch: AppEventStreams['board:patch']) =>
//     broker.get(BoardModel, patch.id)?.update(patch);

export const ManageBillingSettingsViewScope = createScope({
    async refresh(p, c) {

        const api = c.get(ApiClient);
        const broker = c.get(ModelBroker);
        const evts = c.get(AppEvents);

        const data = await api.exec(v2.admin.billing.info());
        const model = broker.allocate(ManageBillingSettingsModel);
        model.update(data);

        c.bind(ManageBillingSettingsModel).toConstantValue(model);

        return [
            evts.on('settings:patch', (patch) => {
                for (const key of Object.keys(patch)) {
                    if (!key.startsWith('billing.')) continue;
                    model.update(x => x.settings[key.replace('billing.', '')] = patch[key]);
                }
            }),
        ];
    }
});
